import { FlagTypes } from '@boltenergy-be/design-system'

export type BannerProps = {
  onClick: () => void
}

export enum BannerTypes {
  BRUSSELS_BEER_PROJECT = 'brusselsBeerProject',
  VIA_VIA = 'copy',
  SIMULATION_DOWN = 'simulationDown'
}

export type PredefinedBanner = {
  type: FlagTypes
  titleNsAndKey: string
  descriptionNsAndKey?: string
}
